const getLineItemPrice = (priceObj)=>{
    var ref, ref1;
    const total = priceObj.total;
    const unit = priceObj.unit;
    var ref2, ref3;
    return {
        total: {
            discount: total.discount.amount,
            original: total.subtotal,
            gross: total.gross,
            net: total.net,
            taxAmount: total.tax.amount,
            taxRate: (ref2 = (ref = total.tax.portions[0]) === null || ref === void 0 ? void 0 : ref.rate) !== null && ref2 !== void 0 ? ref2 : 0
        },
        unit: {
            discount: unit.discount.amount,
            original: unit.subtotal,
            gross: unit.gross,
            net: unit.net,
            taxAmount: unit.tax.amount,
            taxRate: (ref3 = (ref1 = unit.tax.portions[0]) === null || ref1 === void 0 ? void 0 : ref1.rate) !== null && ref3 !== void 0 ? ref3 : 0,
            appliedDiscounts: unit.discount.appliedDiscounts.map((discountItem)=>({
                    type: discountItem.type,
                    amount: discountItem.amount
                })
            )
        }
    };
};

export { getLineItemPrice };
//# sourceMappingURL=get-line-item-price.js.map
